import React from "react";
import { Card, CardContent, CardHeader, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { StackedBarChart } from "../../../../components/charts/BarChart";
import BarChartIcon from '@mui/icons-material/BarChart';
import TableChartIcon from '@mui/icons-material/TableChart';
import MaterialTable from "../../../../common/MaterialTable";
import { avgPickupAgeing, transformChartDataToTable } from "../../../../helpers/UtilityHelper";

export default function CourierWiseSplit({ data }) {

    const [view, setView] = React.useState("chart")

    const stackedBarChartOptions = {
        xaxis: 'name',
        stackId: 'ageingPercentage',
        labelY: 'Percentage',
        legendAlign: 'left',
        data: avgPickupAgeing.map((z) => ({ dataKey: `${z}_perc`, label: z.replace(/_/g, " "), unit: '%' }))
    }


    const { rows, allColumns } = transformChartDataToTable(data.courierWiseAgeing, avgPickupAgeing.map((z) => {
        const key = `${z}_perc`
        return { key, label: z.replace(/_/g, ' ') }
    }))

    const tableColumns = [
        {
            label: 'Name',
            value: 'name',
            align: 'left'
        },
        ...(allColumns.map((z) => ({
            numeric: true,
            align: 'right',
            value: (row) => {
                return row[z] + '%'
            },
            label: z
        })))
    ]

    const modifiedData = data?.courierWiseAgeing?.map(item => ({
        ...item,
        // name: item.name.split('/')[0] +"\r\n (" +item.name.split('/')[1]
        name: item.name.split('/')[0]
    })) || [];

    return (
        <Card elevation={1}>
            <CardHeader title="Courier Wise Ageing" action={(
                <ToggleButtonGroup color="primary" size="small" exclusive onChange={(e, v) => setView(v)} value={view}>
                    <ToggleButton value="chart">
                        <BarChartIcon />
                    </ToggleButton>
                    <ToggleButton value="table">
                        <TableChartIcon />
                    </ToggleButton>
                </ToggleButtonGroup>
            )} />
            <CardContent sx={{ px: 0 }}>
                {view === 'chart' && (
                    <StackedBarChart data={modifiedData} height={450} chartOptions={stackedBarChartOptions} rotateLabels={true}  />
                )}
                {view === 'table' && (
                    <MaterialTable size="small" exportExcel={false} rows={rows} columns={tableColumns} frozenColumnsCount={1} />
                )}
            </CardContent>
        </Card>
    )
}